import { CartProductDetails } from './ItemDetails';
import { Product } from '@interfaces';

import {
  RootDiv,
  ProductQuantity,
  VerticalLine,
  ImgProduct,
  ImgDiv,
  SkeletonImg,
  SkeletonText,
  SkeletonQuantity,
} from '../styles/Item.styles';
import { useState } from 'react';

interface ItemProps {
  product: Product;
  price: number;
  quantity: number;
}

export function Item(props: ItemProps) {
  const { product, price, quantity } = props;
  const loading = false;
  const [imageUrl, setImageUrl] = useState(product.imagesUrl[0]);
  const handleImageError = () => {
    setImageUrl('/assets/images/default.webp');
  };

  return (
    <RootDiv>
      {loading ? (
        <SkeletonQuantity variant="rectangular" />
      ) : (
        <ProductQuantity>{quantity}</ProductQuantity>
      )}
      {loading ? (
        <SkeletonImg variant="rectangular" />
      ) : (
        <ImgDiv>
          <ImgProduct src={imageUrl} onError={handleImageError} />
        </ImgDiv>
      )}
      <VerticalLine />
      {loading ? (
        <SkeletonText variant="rectangular" />
      ) : (
        <CartProductDetails
          product={product}
          price={price}
          quantity={quantity}
        />
      )}
    </RootDiv>
  );
}
